// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1784":"fbe190fb","3652":"a93692bc","5157":"f0f5595d","5981":"6a10adf4","8703":"9d35bc13"}[chunkId] + ".chunk.css";
};